import axios from 'axios'
const http = axios.create({
  //http://5f9829.natappfree.cc/report/student-detail/1/1
  baseURL: process.env.API_ROOT
});

export default function request(url) {
  return new Promise((resolve, reject) => {
    http.get(url).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/http.js